import { combineReducers } from 'redux';

import appReducer from './app/appReducer';
import authReducer from './auth/authReducer';
import transitionsReducer from './transitions/transitionsReducer';
import rightsReducer from './rights/rightsReducer';
import projectsInfoReducer from './projectsInfo/projectsInfoReducer';
import lastUpdateInfoReducer from './lastUpdateInfo/lastUpdateInfoReducer';
import adminStatsReducer from './adminStats/adminStatsReducer';
import globalAdminStatsReducer from './globalAdminStats/globalAdminStatsReducer';
import trtReducer from './trt/trtReducer';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  transitions: transitionsReducer,
  rights: rightsReducer,
  projectsInfo: projectsInfoReducer,
  updateInfo: lastUpdateInfoReducer,
  adminStats: adminStatsReducer,
  globalAdminStats: globalAdminStatsReducer,
  trt: trtReducer,
});

export default rootReducer;
